import { render, staticRenderFns } from "./ItPlanning.vue?vue&type=template&id=0bf0b893"
import script from "./ItPlanning.vue?vue&type=script&lang=js"
export * from "./ItPlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf0b893')) {
      api.createRecord('0bf0b893', component.options)
    } else {
      api.reload('0bf0b893', component.options)
    }
    module.hot.accept("./ItPlanning.vue?vue&type=template&id=0bf0b893", function () {
      api.rerender('0bf0b893', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/ItPlanning.vue"
export default component.exports